export const makeAccessText = (text: string) => {
  return (
    text.split('\n')[0]?.replace('・', '、').trim() ??
    text.replace('・', '、').trim()
  )
}
